import React, {useEffect} from "react";
import PropTypes from "prop-types";

import { CacheProvider } from "@emotion/react";
import {CssBaseline} from "@mui/material";
import ThemeProvider from "../theme/ThemeProvider";
import {ApolloProvider} from "@apollo/client";
import createEmotionCache from "../utility/createEmotionCache";

import {createClient} from "components/Apollo/index.ts";
import Head from "next/head";
import BoxedSidebarLayout from "../layout/BoxedSidebarLayout";
import dayjs from "dayjs";
import {useTranslation} from "react-i18next";
import relativeTime from "dayjs/plugin/relativeTime";
import {Toaster} from "react-hot-toast";
import { Analytics} from "@vercel/analytics/react";
import KeycloakProvider	 from "../src/keycloak";
import {useKeycloak} from "../src/useKeycloak";
import("dayjs/locale/nb");

const clientSideEmotionCache = createEmotionCache();
const KeycloakReady = ({children}) => {
	const {ready} = useKeycloak();
	if (!ready) return null;
	return children;
};
const SetupApollo = ({Component, pageProps}) => {

	// const client = useClient("https://api.buildtest.swosj.com/v1/graphql", { role: "operator"});
	const getLayout = Component.getLayout || ((page) => page);
	const {token, tokenParsed, date} = useKeycloak();
	let role = "operator";
	 if (tokenParsed.resource_access.youtello.roles.indexOf("operatorphonero") !== -1) {
	 	role = "operatorphonero";
	 }
	 else if (tokenParsed.resource_access.youtello.roles.indexOf("operatortelia") !== -1) {
	 	role = "operatortelia";
	 }



	const client = createClient(process.env.NEXT_PUBLIC_APOLLO_CLIENT_GRAPHQL_URL, {token: token, role});
	return (
		<ApolloProvider client={client}>
			<BoxedSidebarLayout>
				<Toaster position="bottom-right"/>
				{getLayout(<Component {...pageProps} />)}
				<Analytics/>
			</BoxedSidebarLayout>
		</ApolloProvider>
	);
};


const WaitForInitializing = (props) => {
	const {  emotionCache = clientSideEmotionCache, pageProps, Component } = props;
	// console.log("[KeycloakProvider render]");
	return (
		<CacheProvider value={emotionCache}>
			<Head>
				<link rel="shortcut icon" href="/youtello_logo.png" />
				<title>Youtello web</title>
			</Head>
			<ThemeProvider>
				<CssBaseline />
				<KeycloakProvider config={
					{
						url: process.env.NEXT_PUBLIC_KEYCLOAK_ISSUER,
						realm: process.env.NEXT_PUBLIC_KEYCLOAK_REALM,
						clientId: process.env.NEXT_PUBLIC_KEYCLOAK_CLIENTID
					}

				}>
					<KeycloakReady>
						<SetupApollo {...props}/>
					</KeycloakReady>
				</KeycloakProvider>
			</ThemeProvider>
		</CacheProvider>
	);
};

function SafeHydrate({ children }) {
	return (
		<div suppressHydrationWarning>
			{typeof window === "undefined" ? null : children}
		</div>
	);
}

const WebClient = (props ) => {
	const {  emotionCache = clientSideEmotionCache, pageProps, Component } = props;
	const {i18n} = useTranslation();
	dayjs.locale(i18n.language);
	dayjs.extend(relativeTime);
	return (
		<SafeHydrate>

			<WaitForInitializing {...props}/>
		</SafeHydrate>
	);
};

export default WebClient;

WebClient.propTypes = {
	Component: PropTypes.elementType.isRequired,
	emotionCache: PropTypes.object
//  pageProps: PropTypes.object.isRequired,
};
